import * as moment from 'moment';

export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATETIME_FORMAT = 'YYYY-MM-DD HH:mm';

export class DateModel {
  date: string;
  horAsOf: number;
  horUpTo: number;

  constructor(objIn: any) {
    this.date = objIn.date || moment().format(DATE_FORMAT);
    this.horAsOf = objIn.horAsOf || 1;
    this.horUpTo = objIn.horUpTo || 14;
  }

}
